import {useState} from 'react';
import {useDetectionElement} from '@/hooks/ai.hooks';
// import {useGetFileProcessed} from "@/hooks/sftp.hooks";
import {downloadVideo} from '@/api/sftp/file';

import Card from '@/components/Card';
import Modal from '@/components/Modal';
import BannerImgText from '@/components/BannerImgText';
import FileUpload from '@/components/FileUpload';
import EmptyResult from '@/components/EmptyResult';

import {downloadBase64Image} from '@/utils/file.utils';

const ElementDetectionPage = () => {
  const [file, setFile] = useState<File>();
  const {mutate: mutateDetect, isPending, data} = useDetectionElement();
  // const {mutate: mutateSFTP} = useDownloadFileSFTP(); 
  // const { mutate: mutateFile} = useGetFileProcessed();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result: any = data; // I need to create the type for it.


  const HandleDownloadFile = () => {
    if(file) {
      if (result.data.image) {
        downloadBase64Image(result.data.image, file.name);
      }
      if (result.data.file_path) {
        downloadVideo();
        // mutateFile(result.data.filename);
      }
    } 
  }

  return (
    <div className="container">
      <BannerImgText title="Détection des éléments" img="media/ia-images/detect_element.webp" />
      <div className="grid md:grid-cols-2 gap-3">
        <Card title="Séléction des photos / vidéos">
          <div className="mb-5">
            <FileUpload setFileUpload={setFile}/>
          </div>
          <div className="text-center">
            <button className="btn btn-fill btn-primary justify-center w-auto min-w-20" disabled={!file} onClick={() => mutateDetect(file)}>{isPending ? '...En Cours' : 'GO'  }</button>
          </div>
        </Card>
        <Card title="Elément détecter">
          <div className={(data || isPending) ? 'hidden' : ''}>
            <EmptyResult text="Aucune analyse trouvé" />
          </div>
          {isPending && 
              <img  className="m-auto" src="./loading.svg"  />
          }
          {!isPending && data && (
            <div className={data ? '' : 'hidden'}>
              <div className="flex flex-wrap gap-2 mb-4">
                {result?.data?.detected_classes?.map((detect, index) => (
                  <span key={index} className="badge badge-lg badge-outline badge-primary">{detect}</span>
                ))}
              </div>
              <div className="flex flex-start gap-1">
                <button className="btn btn-fill btn-light" onClick={HandleDownloadFile}>
                  <i className="ki-filled ki-cloud-download"></i>
                    Télécharger le fichier
                </button>
                <button className="btn btn-primary btn-fill w-fit" data-modal-toggle="#modal-file-view">
                  <i className="ki-filled ki-eye">
                  </i>
                    Aperçu
                </button>
              </div>
                
            </div>
          )}
        </Card>
      </div>
      <Modal
        id="modal-file-view"
        title='Aperçu'
        showSecondBtn
        secondBtnLabel='Télécharger'
        size='large'
        onClickSecondBtn={HandleDownloadFile}
      >
        {!isPending && data &&
          <img className="m-auto max-h-svh" src={`data:image/jpeg;base64,${result.data.image}`} />
        }
      </Modal>
    </div>
  );
}

export default ElementDetectionPage;